import createKindeClient from "@kinde-oss/kinde-auth-pkce-js";

export const kindeClient = await createKindeClient({
  client_id: import.meta.env.VITE_KINDE_CLIENT_ID,
  domain: import.meta.env.VITE_KINDE_DOMAIN,
  logout_uri: import.meta.env.VITE_KINDE_LOGOUT_URL,
  redirect_uri: import.meta.env.VITE_KINDE_REDIRECT_URL,
  is_dangerously_use_local_storage: !import.meta.env.PROD, // true, // TODO: Only do this in development (waiting for auth domains to verify)
});
